import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CredentialsModalField {
  key: string;
  label: string;
  placeholder: string;
  type?: 'text' | 'password';
  /** When true, the field must be non-empty to submit. Defaults to false. */
  required?: boolean;
}

export interface CredentialsModalConfig {
  title: string;
  description?: string;
  logoUrl?: string;
  logoAlt?: string;
  primaryButtonText?: string;
  cancelButtonText?: string;
  fields: CredentialsModalField[];
  initialValues?: Record<string, string>;
}

/** Result is a map of field key to value. */
export type CredentialsModalResult = Record<string, string>;

@Component({
  selector: 'app-credentials-modal',
  templateUrl: './credentials-modal.component.html',
  styleUrls: ['./credentials-modal.component.scss'],
  standalone: false,
})
export class CredentialsModalComponent {
  values: Record<string, string> = {};
  primaryButtonText = 'Connect';
  cancelButtonText = 'Cancel';

  constructor(
    public dialogRef: MatDialogRef<CredentialsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CredentialsModalConfig,
  ) {
    this.primaryButtonText = data.primaryButtonText ?? 'Connect';
    this.cancelButtonText = data.cancelButtonText ?? 'Cancel';
    for (const field of data.fields) {
      this.values[field.key] = data.initialValues?.[field.key] ?? '';
    }
  }

  get canSubmit(): boolean {
    return this.data.fields
      .filter((f) => f.required === true)
      .every((f) => !!this.values[f.key]?.trim());
  }

  isRequired(field: CredentialsModalField): boolean {
    return field.required === true;
  }

  submit() {
    if (!this.canSubmit) return;
    const result: CredentialsModalResult = {};
    for (const field of this.data.fields) {
      result[field.key] = this.values[field.key].trim();
    }
    this.dialogRef.close(result);
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
